// Borradores de correo: lo que se escribe en Redactar y no se envia queda guardado en este navegador, por persona.
import { useSyncExternalStore } from 'react';

import { readJSON, writeJSON } from './storage';

export type Borrador = { id: string; cuentaId: string; para: string; cc: string; cco: string; asunto: string; texto: string; guardado: number };

const CLAVE = 'consola.borradores';
let lista: Borrador[] = readJSON<Borrador[]>(CLAVE, []);
const oyentes = new Set<() => void>();
const escribir = (l: Borrador[]) => {
  lista = l;
  writeJSON(CLAVE, l);
  oyentes.forEach((f) => f());
};

// Un borrador vale la pena guardarlo si tiene algo mas que la direccion.
export const tieneContenido = (b: Pick<Borrador, 'asunto' | 'texto'>) => !!(b.asunto.trim() || b.texto.trim());

export function guardarBorrador(b: Omit<Borrador, 'guardado'>) {
  if (!tieneContenido(b)) return borrarBorrador(b.id);
  escribir([{ ...b, guardado: Date.now() }, ...lista.filter((x) => x.id !== b.id)].slice(0, 50));
}

export const borrarBorrador = (id: string) => lista.some((x) => x.id === id) && escribir(lista.filter((x) => x.id !== id));

export const nuevoIdBorrador = () => `b${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;

export const useBorradores = () =>
  useSyncExternalStore(
    (f) => (oyentes.add(f), () => oyentes.delete(f)),
    () => lista,
  );
